module.exports = __webpack_public_path__ + "img/horizontal_6_6_pp1_9016.849e43ab.png";